<!--
  TODO refactor style
  
  Component is used from plugin. Check 'InfoModalPlugin.js' for details.
-->

<template>
  <b-modal
    ref="infoModal"
    modal-class="info-modal"
    size="lg"
    :title="title"
    :header-bg-variant="variant">

    <div>
      <p>{{ message }}</p>
      <!-- TODO style it when info modal gets styled -->
      <div v-if="list.length">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index">
            {{index}}: {{item}}
          </li>
        </ul>
      </div>
      <b-button
        v-if="hasCallback"
        variant="outline-primary"
        @click="confirm()">
        {{ confirmButtonText }}
      </b-button>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<style>
.info-modal .modal-content {
  border-radius: 0.3rem!important;
}

.info-modal .modal-body {
  padding: 20px!important;
}

.info-modal .modal-body button {
  margin-top: 20px;
}
</style>

<script>
export default {
  name: 'InfoModalComponent',
  data() {
    return {
      hasCallback: false,
      confirmButtonText: 'Confirm',
      list: [],
      title: '',
      message: '',
      variant: '',
      onConfirmCallback() {},
    };
  },
  beforeMount() {
    this.$infoModalEventBus.$on('show', (params) => {
      this.show(params);
    });
  },
  methods: {
    show(params) {
      this.title = params.title || params.type;
      this.message = params.message || 'Error';
      this.list = params.list || [];
      if (typeof params.confirmCallback === 'function') {
        this.hasCallback = true;
        this.onConfirmCallback = params.confirmCallback;
      } else {
        this.hasCallback = false;
      }
      if (params.type === 'ERROR') {
        this.variant = 'danger';
      } else if (params.type === 'WARNING') {
        this.variant = 'warning';
      } else {
        this.variant = 'info';
        if (!this.title) { this.title = 'INFO'; }
      }
      this.confirmButtonText = (params.confirmButtonText) ? params.confirmButtonText : 'Confirm';
      this.$refs.infoModal.show();
    },
    hide() {
      this.$refs.infoModal.hide();
    },
    confirm() {
      this.onConfirmCallback();
      this.hide();
    },
  },
};
</script>
